import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TranslateBlockDirective } from '@ngx-translate/core';
import { ButtonIconComponent } from '../../../../../../shared/components/button-icon/button-icon.component';
import { InputCalendarComponent } from '../../../../../../shared/components/calendar/calendar.component';
import { InputCalendarInterface } from '../../../../../../types/interfaces/input.interface';

@Component({
  selector: 'app-date-range',
  imports: [
    InputCalendarComponent,
    ButtonIconComponent,
    TranslateBlockDirective,
  ],
  templateUrl: './date-range.html',
  styleUrl: './date-range.css',
})
export class DateRange {
  @Input()
  public reportForm!: FormGroup;

  public get dateFromConfig(): InputCalendarInterface {
    return {
      formGroup: this.reportForm,
      id: 'dateFrom',
      isTranslated: true,
      label: 'common.input.data-from.label',
      showIcon: true,
      dateFormat: 'dd.mm.yy',
      showTime: true,
      showClear: true,
      appendTo: 'body',
      showButtonBar: true,
      placeholder: 'common.input.data-from.placeholder',
    };
  }

  public get dateToConfig(): InputCalendarInterface {
    return {
      formGroup: this.reportForm,
      id: 'dateTo',
      label: 'common.input.data-to.label',
      showIcon: true,
      dateFormat: 'dd.mm.yy',
      showTime: true,
      showClear: true,
      appendTo: 'body',
      showButtonBar: true,
      placeholder: 'common.input.data-to.placeholder',
    };
  }

  public setDateRangeDay(days: number): void {
    const date = new Date();
    date.setDate(date.getDate() - days);
    this.reportForm.get('dateFrom')
      ?.setValue(date);
    this.reportForm.get('dateTo')
      ?.setValue(null);
  }

  public setDateRangeMonth(months: number): void {
    const date = new Date();
    date.setMonth(date.getMonth() - months);
    this.reportForm.get('dateFrom')
      ?.setValue(date);
    this.reportForm.get('dateTo')
      ?.setValue(null);
  }
}
